module.exports = __webpack_public_path__ + "img/herb-oregano-350x184.a3c0b878.jpg";